import styled from 'styled-components'
import { truncate, media, rgba, radiuses, colors, input } from 'styles'

const StyledSelect = styled.div`
  position: relative;
  ${input.outer};
  height: 3em;
  transition: box-shadow 0.2s;

  &[disabled] {
    opacity: 0.5;
    pointer-events: none;
    .header {
      border-width: 0.1rem;
    }
  }

  &.open {
    z-index: 10;
    .header {
      padding-right: 0;
      box-shadow: 0 0.2rem 1rem ${colors.divider};
      background: ${colors.mainBackground};
      i {
        margin: 0 1rem;
        transform: rotate(-180deg);
      }
      .ui-option {
        margin: 0.5rem;
        + .ui-option {
          margin-top: 0;
        }
      }
      .header__text {
        white-space: normal;
        overflow: visible;
      }
    }
    .options {
      box-shadow: 0 0 1rem ${colors.divider};
      max-height: 17rem;
    }
  }
  &.open.long {
    .header {
      max-height: 9.5rem;
      overflow-y: auto;
      align-items: start;
      i {
        display: none;
      }
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    min-width: 4rem;
    border: ${input.border};
    border-radius: ${input.borderRadius};
    min-height: 3em;
    padding: 0 ${input.padding} 0 ${p => (p.multiSelect ? 0 : input.padding)};
    text-align: left;
    color: transparent;
    text-shadow: 0 0 0 ${colors.textMain};
    cursor: pointer;
    appearance: none;
    user-select: none;

    &:focus,
    input {
      pointer-events: none;
      opacity: 0;
      z-index: -10;
      position: absolute;
      left: 0;
      border: 0;
      width: 100%;
      box-sizing: border-box;
    }

    .ui-option {
      position: relative;
      display: inline-block;
      padding: 0.2rem 0.5rem;
      margin: 0 0.5rem;
      border: 0.1rem solid ${colors.divider};
      border-radius: ${radiuses.small};
      .fa {
        font-size: 1.75rem;
        vertical-align: middle;
        margin-left: 0.4rem;
        color: ${colors.divider};
        transition: 0.2s ease-in-out;
        &:hover {
          color: ${colors.highlight};
        }
      }
    }
  }

  .header__text {
    ${truncate('100%')}
    line-height: 1.5;
    color: ${colors.textMain};
  }

  .filter {
    background-color: ${colors.mainBackground};
    width: 100%;
    margin-top: 0;
    transition: 0.3s ease-in-out;
    &.hidden {
      margin-top: -0.3rem;
      opacity: 0;
      height: 0;
      min-height: 0;
      border: 0;
      padding: 0;
      pointer-events: none;
      display: block;
    }
  }

  i {
    color: ${colors.textSecondary};
    transition: transform 0.5s;
  }
  .options {
    position: relative;
    width: 100%;
    max-height: 0;
    box-shadow: none;
    box-sizing: border-box;
    background-color: ${colors.mainBackground};
    overflow-y: scroll;
    transition: all 0.3s ease-in-out;
    z-index: 4;
  }
  /* hide reset if there are 0 options (dynamic city) */
  &.no-options .reset {
    display: none;
  }

  ${media.mobile`
    &.open.long .header {
      max-height: 11rem;
    }
  `}
  ${media.phone`
    .options {
      border: ${p => (p.active ? 1 : 0)}px solid ${colors.divider};
      border-top: 0;
    }
  `}
`

const SelectOption = styled.div`
  padding: 0.75em;
  box-sizing: border-box;
  color: ${colors.textMain};
  font-size: ${input.fontSize};
  cursor: pointer;
  background-color: ${p => p.selected && rgba(colors.divider, 0.4)};
  user-select: none;
  &:hover {
    background-color: ${rgba(colors.divider, 0.6)};
  }
  i {
    margin-right: 1.2rem;
  }
`

export default StyledSelect
export { SelectOption }
